import { useAuth } from '../../../hooks/useAuth';
import { usePersona } from '../../../contexts/PersonaContext';
import { UserRole } from '@spi/shared';
import toast from 'react-hot-toast';

export function PersonaSwitcher() {
  const { realUser } = useAuth();
  const { persona, isImpersonating, exitPersona } = usePersona();

  // Only show banner for admins who are impersonating
  if (!realUser || realUser.role !== UserRole.ADMIN || !isImpersonating || !persona) return null;

  const handleExit = () => {
    exitPersona();
    toast.success('Returned to admin view');
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-amber-500 text-white text-center py-1.5 text-sm font-medium shadow-md">
      <span>
        Impersonating <strong>{persona.firstName} {persona.lastName}</strong>
        {persona.organization && <> ({persona.organization.name})</>}
        {' '}&middot; <span className="capitalize">{persona.role}</span>
      </span>
      <button
        onClick={handleExit}
        className="ml-3 px-2 py-0.5 rounded bg-white/20 hover:bg-white/30 text-xs font-semibold transition-colors"
      >
        Stop Impersonating
      </button>
    </div>
  );
}
